import { Link, useNavigation } from 'react-router-dom';
import { Event } from './API';

import './css/EventList.css';

interface EventListItemProps {
  event: Event;
}

function EventListItem({ event }: EventListItemProps) {
  const { eventId, eventName, location, date } = event;
  const navigation = useNavigation();

  const isLoading =
    navigation.state === 'loading' &&
    navigation.location?.pathname === `/${eventId}`;

  const isPastEvent = new Date(date) < new Date(new Date().toDateString());

  const readableDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const className = [
    'event-list-item',
    isPastEvent && 'event-list-item--past',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Link to={`${eventId}`} className={className}>
      <div className="event-information">
        <h2 className="no-margin">{eventName}</h2>
        <address>{location}</address>
        <div className="event-date">{readableDate}</div>
      </div>
      <div className="event-view-details">
        {isLoading ? (
          <div className="spinner" />
        ) : (
          'View Details'
        )}
      </div>
    </Link>
  );
}

export default EventListItem;
